"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("antd/es/input/style/css");

var _input = _interopRequireDefault(require("antd/es/input"));

require("antd/es/form/style/css");

var _form = _interopRequireDefault(require("antd/es/form"));

require("antd/es/modal/style/css");

var _modal = _interopRequireDefault(require("antd/es/modal"));

require("antd/es/button/style/css");

var _button = _interopRequireDefault(require("antd/es/button"));

require("antd/es/checkbox/style/css");

var _checkbox = _interopRequireDefault(require("antd/es/checkbox"));

require("antd/es/table/style/css");

var _table = _interopRequireDefault(require("antd/es/table"));

require("antd/es/select/style/css");

var _select = _interopRequireDefault(require("antd/es/select"));

require("antd/es/collapse/style/css");

var _collapse = _interopRequireDefault(require("antd/es/collapse"));

var _ = _interopRequireWildcard(require("lodash"));

var _moment = _interopRequireDefault(require("moment"));

var _react = _interopRequireWildcard(require("react"));

var _reactRedux = require("react-redux");

var _reselect = require("reselect");

var _Username = _interopRequireDefault(require("../../../components/username/Username"));

var _Util = require("../../../components/util/Util");

var _payment = require("../../../redux/payment/payment.types");

var selectors = _interopRequireWildcard(require("../../../redux/selectors"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

const {
  Panel
} = _collapse.default;
const {
  Option
} = _select.default;
const {
  Column
} = _table.default;
const initialState = {
  checked: {},
  payCheckedModalVisible: false,
  trackingInfo: ''
};

const rowClassName = (record, index) => {
  return index % 2 === 0 ? 'tr-even-color' : 'tr-odd-color';
};

class PaymentsLandingPage extends _react.Component {
  constructor() {
    super(...arguments);
    this.state = initialState;

    this.showPayCheckedModal = () => {
      this.setState({
        payCheckedModalVisible: true
      });
    };

    this.renderUsername = value => {
      const {
        participants
      } = this.props;

      if (participants) {
        const participant = participants.find(p => p.username === value);
        return participant ? /*#__PURE__*/_react.default.createElement(_Username.default, {
          participantId: participant.id
        }) : value;
      }

      return value;
    };
  }

  payAll() {
    this.setState({
      payCheckedModalVisible: true
    });
  }

  markPaid() {
    const ids = _.flatten(_.map(_.values(this.state.checked), val => _.keys(val).map(id => parseInt(id))));

    const markPaidObj = {
      trackingInfo: this.state.trackingInfo,
      incentivePaymentIds: ids
    };
    this.props.markPaid(markPaidObj);
    this.setState({
      checked: {},
      payCheckedModalVisible: false,
      trackingInfo: ''
    });
  }

  componentDidMount() {
    this.props.getPayments();
  }

  paidRenderer(date, payment) {
    const {
      checked
    } = this.state;
    const chk = !!(checked && checked[payment.label] && checked[payment.label][payment.incentivePaymentId]);
    return date ? (0, _moment.default)(date).format('YYYY-MM-DD HH:SSa') : /*#__PURE__*/_react.default.createElement(_checkbox.default, {
      checked: chk,
      onChange: v => {
        const updatedChecked = _.cloneDeep(this.state.checked);

        if (v.target.checked) {
          if (!updatedChecked[payment.label]) {
            updatedChecked[payment.label] = {};
          }

          updatedChecked[payment.label][payment.incentivePaymentId] = true;
        } else {
          delete updatedChecked[payment.label][payment.incentivePaymentId];

          if (_.isEmpty(updatedChecked[payment.label])) {
            delete updatedChecked[payment.label];
          }
        } // console.log(JSON.stringify(updatedChecked));


        this.setState({
          checked: updatedChecked
        });
      }
    });
  }

  checkAll() {
    const {
      payments
    } = this.props;

    const checked = _.reduce(payments, (checked, payment) => {
      if (payment.paidDate) return checked;

      if (!checked[payment.label]) {
        checked[payment.label] = {};
      }

      checked[payment.label][payment.incentivePaymentId] = true;
      return checked;
    }, {});

    this.setState({
      checked
    });
  }

  render() {
    const {
      trackingInfo
    } = this.state;
    const {
      payments
    } = this.props;

    const paymentsById = _.groupBy(payments, 'incentivePaymentId');

    return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("div", {
      className: "actions"
    }, /*#__PURE__*/_react.default.createElement(_button.default, {
      type: "primary",
      onClick: () => this.checkAll()
    }, "Check All"), "\u00A0", /*#__PURE__*/_react.default.createElement(_button.default, {
      type: "primary",
      "aria-disabled": _.isEmpty(this.state.checked),
      onClick: () => this.payAll()
    }, "Process Payment")), /*#__PURE__*/_react.default.createElement("br", null), /*#__PURE__*/_react.default.createElement(_table.default, Object.assign({}, this.state, {
      dataSource: payments,
      rowClassName: rowClassName,
      rowKey: "incentivePaymentId",
      scroll: {
        y: 'calc(100vh - 200px)'
      },
      pagination: false
    }), /*#__PURE__*/_react.default.createElement(Column, {
      title: "ID",
      dataIndex: "incentivePaymentId",
      key: "incentivePaymentId",
      sorter: (a, b) => a.incentivePaymentId - b.incentivePaymentId
    }), /*#__PURE__*/_react.default.createElement(Column, {
      title: "Label",
      dataIndex: "label",
      key: "label",
      sorter: (a, b) => `${a.label}`.localeCompare(b.label),
      filters: _.map(_.sortedUniq(_.uniq(_.sortBy(_.map(payments, 'label')))), x => {
        return {
          text: x,
          value: x
        };
      }),
      onFilter: (value, record) => record.label === value
    }), /*#__PURE__*/_react.default.createElement(Column, {
      title: "Username",
      dataIndex: "participant.username",
      key: "username",
      render: this.renderUsername,
      sorter: (a, b) => `${a.participant.username}`.localeCompare(b.participant.username),
      filters: _.map(_.sortedUniq(_.uniq(_.sortBy(_.map(payments, 'participant.username')))), x => {
        return {
          text: x,
          value: x
        };
      }),
      onFilter: (value, record) => record.participant.username === value
    }), /*#__PURE__*/_react.default.createElement(Column, {
      title: "Amount",
      dataIndex: "amount",
      key: "amount",
      render: amount => `$${amount}`,
      sorter: (a, b) => a.amount - b.amount
    }), /*#__PURE__*/_react.default.createElement(Column, {
      title: "Create Date",
      dataIndex: "createDate",
      key: "createDate",
      render: _Util.renderDateWithoutTime,
      sorter: (a, b) => (0, _moment.default)(a.createDate).unix() - (0, _moment.default)(b.createDate).unix()
    }), /*#__PURE__*/_react.default.createElement(Column, {
      title: "Paid",
      dataIndex: "paidDate",
      key: "paidDate",
      render: this.paidRenderer.bind(this),
      defaultSortOrder: "descend",
      sorter: (a, b) => {
        if (!a.paidDate && !b.paidDate) return 0;
        if (!a.paidDate && b.paidDate) return 1;
        if (a.paidDate && !b.paidDate) return -1;
        return (0, _moment.default)(a.paidDate).unix() - (0, _moment.default)(b.paidDate).unix();
      },
      filters: [{
        text: 'unpaid',
        value: 'unpaid'
      }],
      onFilter: (value, record) => value === 'unpaid' && !record.paidDate
    }), /*#__PURE__*/_react.default.createElement(Column, {
      title: "Order Number",
      dataIndex: "trackingInfo",
      key: "trackingInfo",
      sorter: (a, b) => `${a.trackingInfo}`.localeCompare(b.trackingInfo)
    }))), /*#__PURE__*/_react.default.createElement(_modal.default, {
      title: "Process Payment",
      visible: this.state.payCheckedModalVisible,
      okText: "Mark Paid",
      onOk: () => this.markPaid(),
      okButtonProps: {
        disabled: _.isEmpty(this.state.trackingInfo)
      },
      onCancel: () => {
        this.setState({
          payCheckedModalVisible: false,
          trackingInfo: ''
        });
      }
    }, /*#__PURE__*/_react.default.createElement("div", null, _.keys(this.state.checked).map(key => /*#__PURE__*/_react.default.createElement("div", {
      key: key
    }, /*#__PURE__*/_react.default.createElement("h4", null, key, ' ', "$", _.find(payments, p => p.label === key).amount), /*#__PURE__*/_react.default.createElement("p", null, _.keys(this.state.checked[key]).map(id => paymentsById[id][0].participant.email).join(', ')))), /*#__PURE__*/_react.default.createElement("br", null), /*#__PURE__*/_react.default.createElement(_form.default.Item, {
      label: "Order Number"
    }, /*#__PURE__*/_react.default.createElement(_input.default, {
      allowClear: true,
      value: trackingInfo,
      style: {
        width: 320
      },
      onChange: v => {
        this.setState({
          trackingInfo: v.target.value
        });
      }
    })), /*#__PURE__*/_react.default.createElement("br", null), /*#__PURE__*/_react.default.createElement("br", null))));
  }

}

const mapStateToProps = (0, _reselect.createStructuredSelector)({
  payments: selectors.getPayments,
  participants: selectors.getRequestedStudyParticipants
});

const mapDispatchToProps = dispatch => {
  return {
    getPayments: () => dispatch(_payment.getPaymentsAsync.request()),
    markPaid: markPaid => dispatch(_payment.markPaidAsync.request(markPaid))
  };
};

var _default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(PaymentsLandingPage);

exports.default = _default;